import { AscEventName } from '../interfaces/interface.asc-analytics';
import { state as bannerState } from '../store/store.interactive-banner';

import { BannerStep } from './utils.interactive-banner';
import { QUESTION_CERTIFIED_CARS, QUESTION_MAKE_MODEL, QUESTION_NEW_CARS, QUESTION_USED_CARS, QUESTION_YEAR_RANGE } from './utils.question';

export const ASC_TRACKING_EVENT_NAME = 'AscTrackingEvent';

export const ASC_EVENTS: Record<string, AscEventName> = {
  PAGE_VIEW: 'asc_pageview',
  RETAIL_PROCESS: 'asc_retail_process',
  CTA_INTERACTION: 'asc_cta_interaction',
};

const ELEMENT_TITLES = {
  vin: 'vin',
  licensePlate: 'license_plate',
  ymm: 'make_model',
};

/* eslint-disable camelcase */
export const ACS_EVENT_PROPS = {
  NEXT: {
    element_text: 'Next',
    event_action_result: 'complete',
    flow_outcome: 'proceed',
  },
  CONTINUE: {
    element_text: 'Continue',
    event_action_result: 'start',
    flow_outcome: 'proceed',
  },
  VIEW_OFFER_CERTIFICATE: {
    element_text: 'View Offer Certificate',
    event_action_result: 'open',
  },
  START_MY_OFFER: {
    element_text: 'Start My Offer',
    event_action_result: 'start',
    flow_outcome: 'start',
  },
  START_MY_OFFER_ERROR: {
    element_text: 'Start My Offer',
    event_action_result: 'error',
    flow_outcome: 'error',
  },
  CHANGE_VEHICLE: {
    element_text: 'Change Vehicle',
    event_action_result: 'restart',
    flow_outcome: 'back',
  },
  START_A_NEW_OFFER: {
    element_text: 'Start a New Offer',
    event_action_result: 'restart',
    flow_outcome: 'back',
  },
  WHERE_IS_MY_VIN: {
    element_text: 'Where is my VIN?',
    event_action_result: 'popup',
  },
  SEE_LISTING: {
    element_text: 'Click here to see listing',
    event_action_result: 'open',
  },
};

export const ENGAGEMENT_FORMS = {
  customerContact: 'customerContact',
};

export const getElementTitle = (eventProps) => {
  const { element_text } = eventProps;
  const { activeStep, currentSelectedTab } = bannerState;
  if (['Continue', 'Start My Offer'].includes(element_text)) {
    return ELEMENT_TITLES[currentSelectedTab];
  } else if (element_text === 'Next' || activeStep === BannerStep.MSM) {
    if (bannerState.isActiveListing) {
      return 'active_listing';
    }

    return 'mileage';
  } else if (activeStep === BannerStep.Continue) {
    return 'continue';
  } else if (activeStep === BannerStep.NotQualify) {
    return 'ineligible';
  } else if ([BannerStep.Eligible, BannerStep.Review, BannerStep.Inspection].includes(activeStep)) {
    return 'certificate';
  }
};

export const FIELDS_TO_TEXT = {
  firstName: 'First Name',
  lastName: 'Last Name',
  email: 'Email Address',
  phone: 'Phone Number',
  zip: 'ZIP Code',
  legalAcceptance: 'I accept the Program Terms and Conditions',
  OptIn: 'Yes',
  OptOut: 'No',
  CashOffer: 'No',
  [QUESTION_NEW_CARS]: 'New Cars',
  [QUESTION_CERTIFIED_CARS]: 'Certified Pre-Owned Cars',
  [QUESTION_USED_CARS]: 'Used Cars',
  min: 'From Year',
  max: 'To Year',
  make: 'Make',
  model: 'Model',
};

/* eslint-enable camelcase */

export const getFormEngageField = (canonicalName, answerKey, answerState, answerValue) => {
  switch (answerKey) {
    case QUESTION_YEAR_RANGE:
      return getMinMaxChange(answerState[canonicalName][answerKey]?.value, answerValue);
    case QUESTION_MAKE_MODEL:
      return getMakeModelChange(answerValue);
    default:
      break;
  }
};

export const getMinMaxChange = (oldYearRange, newYearRange) => {
  const [oldMin, oldMax] = oldYearRange?.split(',');
  const [newMin, newMax] = newYearRange?.split(',');

  if (oldMin !== newMin) {
    return 'min';
  } else if (oldMax !== newMax) {
    return 'max';
  }
  return '';
};

const getMakeModelChange = (makeModelValue) => {
  if (!makeModelValue) {
    return '';
  }
  const [, make, model] = makeModelValue.split('/');
  if (model) {
    return 'model';
  } else if (make) {
    return 'make';
  }
  return '';
};
